import {
    ORDER_RECEIVE,
    ORDER_HISTORY_LOADING,
    ORDER_ERROR,
    ORDER_CHANGE_CURRENTPAGE,
    ORDER_SET_ORDER,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    list: [],
    order: {},
    totalCount: 0,
    showOnlyMyOrders: false,
    errors: {},
    isLoading: true,
};

export const order = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ORDER_HISTORY_LOADING:
            return { ...state, isLoading: true };
        case ORDER_RECEIVE:
        case ORDER_CHANGE_CURRENTPAGE:
        case ORDER_SET_ORDER:
            return {
                ...state,
                errors: {},
                isLoading: false,
                ...payload,
            };
        case ORDER_ERROR:
            return {
                ...state,
                isLoading: false,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
